"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumnTextFilterConfig = void 0;
const react_1 = require("react");
const constants_1 = require("../constants");
const localization_1 = require("../../../../localization");
// TODO - EN-4809 - remove after table migration
/** @deprecated - Use useTextColumnFilterSortConfig instead */
const useColumnTextFilterConfig = () => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const matchOptionsTranslate = (0, react_1.useCallback)((value) => t({ key: constants_1.MatchOptionsToMessageKey[value] }), [t]);
    const getFilterConfig = (0, react_1.useCallback)(({ id }) => ({
        key: id,
        matchOptions: constants_1.MATCH_OPTIONS,
        matchOptionsTranslate,
        setText: ({ search, match }) => ({ field: id, search, match }),
        getText: (filters) => { var _a; return (((_a = filters === null || filters === void 0 ? void 0 : filters.text) === null || _a === void 0 ? void 0 : _a[id]) || { field: id }); },
    }), [matchOptionsTranslate]);
    return getFilterConfig;
};
exports.useColumnTextFilterConfig = useColumnTextFilterConfig;
